module.exports = __webpack_public_path__ + "img/lg_ring_g_i_0_0.2e57c5f5.png";